var React = require('react');

function Membership (props) {
    return React.createElement("svg",props,[React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M9.182 10h-4.91v4.91h4.91V10z","key":0}),React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M11.636 5.09H19V19H1V5.09h7.364","key":1}),React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M11.636 6.727H8.364v-4.09C8.364 1.736 9.1 1 10 1c.9 0 1.636.736 1.636 1.636v4.091zM12.455 10.818h3.272M12.455 14.09h3.272","key":2})]);
}

Membership.defaultProps = {"width":"20","height":"20","fill":"none","viewBox":"0 0 20 20","stroke":"#737680"};

module.exports = Membership;

Membership.default = Membership;
